<!-- resources/js/Components/Feedback/FlashToast.vue -->
<script setup>
import { computed } from 'vue'
import { usePage }  from '@inertiajs/inertia-vue3'

const flash = computed(() => usePage().props.value.flash ?? null)
</script>

<template>
  <transition name="fade">
    <div
      v-if="flash"
      :class="[
        'fixed top-4 right-4 z-[60] px-4 py-3 rounded-lg shadow-lg text-sm font-medium',
        flash.type === 'success'
          ? 'bg-green-600 text-white'
          : 'bg-red-600 text-white'
      ]"
    >
      {{ flash.message }}
    </div>
  </transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active { transition: opacity .25s ease; }
.fade-enter-from,
.fade-leave-to     { opacity: 0;   }
</style>
